import { memo, useCallback } from 'react';
import { Button, Tooltip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { Trash2 } from 'lucide-react';

/**
 * Trailing icon button of a members-table row: removes the member from the group at once (no
 * confirm; the Undo toast is the safety net). The caller wraps it in `<Can>`, which passes
 * `disabled` in lock mode.
 *
 * @param {object} props
 * @param {{ id: string, name: string }} props.member
 * @param {(member: object) => void} props.onRemove Stable callback.
 * @param {boolean} [props.disabled]
 */
const RemoveFromGroupButton = ({ member, onRemove, disabled = false }) => {
  const { t } = useTranslation('people-access');
  const handleClick = useCallback(() => onRemove(member), [onRemove, member]);

  return (
    <Tooltip content={t('groups.removeMember.tooltip')}>
      <Button
        variant="ghost"
        size="sm"
        leftIcon={Trash2}
        aria-label={t('groups.removeMember.buttonLabel', { name: member.name })}
        disabled={disabled}
        onClick={handleClick}
      />
    </Tooltip>
  );
};

export default memo(RemoveFromGroupButton);
